import { render, staticRenderFns } from "./answersPeopleNewadded2.vue?vue&type=template&id=61f7e9ee&scoped=true&"
import script from "./answersPeopleNewadded2.vue?vue&type=script&lang=js&"
export * from "./answersPeopleNewadded2.vue?vue&type=script&lang=js&"
import style0 from "./answersPeopleNewadded2.vue?vue&type=style&index=0&id=61f7e9ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f7e9ee",
  null
  
)

export default component.exports